import { useCssVars as _useCssVars, unref as _unref, defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass } from "vue"

const _hoisted_1 = ["for"]
const _hoisted_2 = ["id", "type", "placeholder", "value"]
const _hoisted_3 = {
  key: 0,
  class: "extra-text error-text"
}
const _hoisted_4 = {
  key: 1,
  class: "extra-text caption"
}

import { PropType, computed, ref } from "vue";


export default /*@__PURE__*/_defineComponent({
  __name: 'Input',
  props: {
  id: {
    type: String,
    default: () => Math.random().toString(16),
  },
  type: {
    type: String as PropType<"text" | "date" | "time">,
    default: "text",
  },
  label: {
    type: String,
    default: "Label not set",
  },
  minLabelWidth: {
    type: Number,
    default: 0,
  },
  modelValue: {
    type: String,
    default: "",
  },
  errorText: {
    type: String,
  },
  caption: {
    type: String,
    default: "",
  },
  placeholder: String,
  validator: {
    type: Function as PropType<(value: string) => boolean>,
    default: () => true,
  },
},
  emits: ["update:modelValue"],
  setup(__props, { emit: __emit }) {

_useCssVars(_ctx => ({
  "c9fd5a10": (minLabelWidthStyle.value)
}))

const props = __props;

const emit = __emit;

const isValid = computed(() => props.validator(props.modelValue));
const minLabelWidthStyle = computed(() => `${props.minLabelWidth}px`);

const containerClasses = computed(() => ({
  ["input-container"]: true,
  error: !isValid.value && touched.value,
}));

const touched = ref(false);

const onBlur = (e: any) => {
  emit("update:modelValue", e.target?.value?.trim());
  touched.value = true;
};

const shouldErrorShown = computed(
  () => !isValid.value && touched.value && props.errorText
);
const shouldCaptionShown = computed(
  () => !shouldErrorShown.value && props.caption
);

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(containerClasses.value)
  }, [
    _createElementVNode("label", {
      class: "label",
      for: __props.id
    }, _toDisplayString(__props.label), 9, _hoisted_1),
    _createElementVNode("input", {
      id: __props.id,
      class: "input",
      type: __props.type,
      placeholder: __props.placeholder,
      value: __props.modelValue,
      onInput: _cache[0] || (_cache[0] = (e) => _ctx.$emit('update:modelValue', e.target.value)),
      onBlur: onBlur
    }, null, 40, _hoisted_2),
    (shouldErrorShown.value)
      ? (_openBlock(), _createElementBlock("p", _hoisted_3, _toDisplayString(__props.errorText), 1))
      : _createCommentVNode("", true),
    (shouldCaptionShown.value)
      ? (_openBlock(), _createElementBlock("p", _hoisted_4, _toDisplayString(__props.caption), 1))
      : _createCommentVNode("", true)
  ], 2))
}
}

})